module.exports = __webpack_public_path__ + "static/media/community.c20bdc95.jpg";